const styleSheet = () => ({
  dropdown: {
    height: '149px',
    width: '183px',
    border: '1.2px solid',
    borderRadius: '4px',
    overflow: 'hidden',
    overflowY: 'auto',
    backgroundColor: 'white',
    zIndex: 24,
  },
  multiSelectInput: {
    position: 'relative',
    zIndex: 25,
  },
  unSelected: {
    borderColor: '#6373A44D',
  },
  selected: {
    borderColor: '#085FE54D',
  },
  selectedText: {
    color: '#085FE5',
  },
  unSelectedText: {
    color: '#6373A4',
  },
  hidden: {
    display: 'none',
  },
  dropdownItem: {
    display: 'flex',
    padding: '4px 0',
    cursor: 'pointer',
  },
  dropdownItemCheckbox: {
    padding: '0 11px 0 5.5px',
  },
  dropdownItemText: {
    display: 'block',
    height: '18px',
    width: '139px',
    padding: '0 4px 0 0',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '18px',
    whiteSpace: 'nowrap',
  },
  divider: {
    border: '1px solid #085FE5',
    margin: '0 4px',
    opacity: '0.3',
  },
  input: {
    display: 'inline-block',
    margin: '0',
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    '&:-ms-input-placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    caretColor: '#085FE5',
    width: '183px',
    height: '28px',
    objectFit: 'contain',
    border: '1.2px solid #6373A44D',
    borderRadius: '4px',
    boxSizing: 'border-box',
    color: '#6373A4',
    padding: '7px 10px 6px 10px',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '15px',
    backgroundColor: '#FFF',
    fontFamily: "'Museo Sans', sans-serif",
  },
  selectedInput: {
    border: '1.2px solid #085FE5',
    '&::placeholder': {
      color: '#085FE5',
    },
  },
});

export default styleSheet;
